import aPlus from '@/assets/illustrations/a-plus.png';
import aceWorkout from '@/assets/illustrations/ace-workout.png';
import jumping from '@/assets/illustrations/jumping.png';
import megaphone from '@/assets/illustrations/megaphone.png';
import octagon from '@/assets/illustrations/octagon.png';
import pi from '@/assets/illustrations/pi.png';
import problem from '@/assets/illustrations/problem.png';
import pyramidDance from '@/assets/illustrations/pyramid-dance.png';
import pyramidFull from '@/assets/illustrations/pyramid-full.png';
import reading from '@/assets/illustrations/reading.png';
import ruler from '@/assets/illustrations/ruler.png';
import skater from '@/assets/illustrations/skater.png';
import sphere from '@/assets/illustrations/sphere.png';
import star from '@/assets/illustrations/star.png';
import stopJump from '@/assets/illustrations/stop-jump.png';
import stopRun from '@/assets/illustrations/stop-run.png';
import telescope from '@/assets/illustrations/telescope.png';
import workout from '@/assets/illustrations/workout.png';

export type IllustrationType =
  | 'jumping'
  | 'problem'
  | 'workout'
  | 'megaphone'
  | 'ace-workout'
  | 'skater'
  | 'reading'
  | 'ruler'
  | 'telescope'
  | 'sphere'
  | 'octagon'
  | 'a-plus'
  | 'pi'
  | 'pyramid-dance'
  | 'pyramid-full'
  | 'star'
  | 'stop-jump'
  | 'stop-run';

const illustrationOrder: IllustrationType[] = ['star', 'workout', 'a-plus', 'pyramid-dance', 'pyramid-full', 'stop-jump', 'stop-run', 'pi'];

const illustrations: Record<IllustrationType, string> = {
  jumping,
  problem,
  workout,
  megaphone,
  'ace-workout': aceWorkout,
  skater,
  reading,
  ruler,
  telescope,
  sphere,
  octagon,
  'a-plus': aPlus,
  pi,
  'pyramid-dance': pyramidDance,
  'pyramid-full': pyramidFull,
  star,
  'stop-jump': stopJump,
  'stop-run': stopRun,
};

type CommonImgProps = React.ImgHTMLAttributes<HTMLImageElement>;

export type IllustrationProps = {
  name?: IllustrationType;
  index?: number;
} & CommonImgProps;

export const Illustration = ({ name, index, ...props }: IllustrationProps) => {
  let illustrationName: IllustrationType;

  if (name) {
    illustrationName = name;
  } else if (index === undefined) {
    illustrationName = illustrationOrder[0];
  } else {
    illustrationName = illustrationOrder[index - 1] ?? illustrationOrder[0];
  }
  return <img src={illustrations[illustrationName]} alt='' {...props} />;
};
